import React from 'react';
import PropTypes from 'prop-types';

import SurveyTemplateCard from './SurveyTemplateCard';

const SurveyTemplateList = ({
  surveyTemplates, viewSurveyDetail, selectSurvey, isTemplateSelected
}) => {

  return (
    <div className="row survey-template-list mt-4">
      {surveyTemplates.map((surveyTemplate) => {
        return (
          <SurveyTemplateCard
            key={surveyTemplate.id}
            surveyTemplate={surveyTemplate}
            viewSurveyDetail={viewSurveyDetail}
            isSelected={isTemplateSelected(surveyTemplate)}
            selectSurvey={selectSurvey}
          />
        );
      })}
    </div>
  );
};

SurveyTemplateList.defaultProps = {
  surveyTemplates: [],
  viewSurveyDetail: () => null,
  selectSurvey: () => null,
  isTemplateSelected: () => null,
};

SurveyTemplateList.propTypes = {
  surveyTemplates: PropTypes.array,
  viewSurveyDetail: PropTypes.func,
  selectSurvey: PropTypes.func,
  isTemplateSelected: PropTypes.func,
};

export default SurveyTemplateList;



// WEBPACK FOOTER //
// ./src/components/survey-templates/SurveyTemplateList.js